import { Component } from 'react';
import { Nav } from '../components';

class MainLayout extends Component {
  render() {
    return (
      <div className='app-container'>
        <Nav />
        <main className='container-fluid pt-4 pb-4'>{this.props.children}</main>
      </div>
    );
  }
}

export { MainLayout };